import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, of} from 'rxjs';
import {PaymentStatus} from '../../shared/models/payment-status.model';
import {PaymentCheckIns} from '../../shared/models/payment-check-ins.model';
import {PaymentCheckoutRequest} from '../../shared/models/payment-checkout-request.model';
import {ApiConfigService} from './api.config.service';

@Injectable({providedIn: 'root'})
export class PaymentsService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService) {
  }

  getPaymentStatus(): Observable<PaymentStatus> {
    const code = this.hoomvipStorage.getCode();
    return this.http.post<PaymentStatus>(this.apiConfigService.getPaymentStatusUrl(), {code});
  }

  getPaymentCheckins(): Observable<PaymentCheckIns> {
    const code = this.hoomvipStorage.getCode();
    return this.http.post<PaymentCheckIns>(this.apiConfigService.getPaymentCheckinsUrl(), {code});
  }

  getPaymentForm(checkin_id: number): Observable<string> {
    const code = this.hoomvipStorage.getCode();
    const request: PaymentCheckoutRequest = {
      code: code,
      checkin_id: checkin_id
    };
    return this.http.post<string>(this.apiConfigService.getPaymentFormUrl(), request);
  }
}
